import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getAssetBalance,
  getAssetId,
  getBalanceReportDate,
  getHouseholdMemberNames,
  getTierMaximum,
  hasKiplingerAccess,
  hasMorningstarAccess,
  showHouseholdDetails
} from 'state/household/HouseholdInformationSelectors';
import { getKiplingerRegistrationUrl } from 'state/kiplingerRegistration/KiplingerRegistrationSelector';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import {
  isProgramBenefits,
  isMobileLayout,
  hasCollegeSavingsOnly
} from 'state/view/ViewSelectors';

const HouseholdDataProvider = (WrappedComponent) => {
  class HouseholdData extends Component {
    render() {
      const {
        assetBalance,
        assetId,
        balanceReportDate,
        styleOverride,
        tierMaximum,
        requestStatus,
        isProgramBenefits,
        isMobile,
        hasCollegeSavingsOnly,
        kiplingerAccess,
        kiplingerRegistrationUrl,
        isCustomerWebView,
        hasMorningstarAccess,
        householdMemberNames,
        showHouseholdDetails,
        showBalance
      } = this.props;

      let isLoading = true;
      let hasError = false;

      const data = {
        assetBalance,
        assetId,
        balanceReportDate,
        styleOverride,
        tierMaximum,
        isProgramBenefits,
        hasCollegeSavingsOnly,
        kiplingerAccess,
        kiplingerRegistrationUrl,
        isCustomerWebView,
        hasMorningstarAccess,
        householdMemberNames,
        showHouseholdDetails,
        showBalance
      };

      if (requestStatus.householdInformation === REQUEST_STATES.received) {
        isLoading = false;
      }

      if (requestStatus.householdInformation === REQUEST_STATES.error) {
        isLoading = false;
        hasError = true;
      }

      if (requestStatus.kiplingerRegistration === REQUEST_STATES.error) {
        isLoading = false;
        hasError = true;
      }

      return (
        <WrappedComponent
          data={data}
          isLoading={isLoading}
          hasError={hasError}
          isMobile={isMobile}
        />
      );
    }
  }

  const mapStateToProps = (state) => ({
    assetBalance: getAssetBalance(state),
    assetId: getAssetId(state),
    balanceReportDate: getBalanceReportDate(state),
    tierMaximum: getTierMaximum(state),
    requestStatus: getRequestStatus(state),
    isProgramBenefits: isProgramBenefits(state),
    isMobile: isMobileLayout(state),
    hasCollegeSavingsOnly: hasCollegeSavingsOnly(state),
    kiplingerAccess: hasKiplingerAccess(state),
    kiplingerRegistrationUrl: getKiplingerRegistrationUrl(state),
    isCustomerWebView: getCustomerWebView(state),
    hasMorningstarAccess: hasMorningstarAccess(state),
    householdMemberNames: getHouseholdMemberNames(state),
    showHouseholdDetails: showHouseholdDetails(state)
  });

  return connect(mapStateToProps)(HouseholdData);
};

export default HouseholdDataProvider;
